// Only once, pick the best matching video uris fast without Alpine
export default class VideoPlayer {
    static init() {
        const videoPlayers = document.querySelectorAll('.video-player__player');
        if (!videoPlayers.length) {
            return;
        }

        Array.from(videoPlayers).forEach(element => {
            new VideoPlayer(element);
        });
    }

    constructor(element) {
        if(!element) return;
        const data = element.getAttribute('data-video-uris');
        if (!data) return;
        const videos = JSON.parse(data);
        const picks = window.innerWidth < 1366 ? videos.uris1366 : videos.uris1920;
        element.innerHTML = picks
            .map((uri) => `<source src="${uri}" type="${uri.endsWith('.mp4') ? 'video/mp4' : 'video/webm'}">`)
            .join('');
    }
}


